import CommonApi from "shared/enums/CommonApi";
import { usePostApiData } from "shared/datalayer";
import { ApiValidateCouponRequest } from "shared/types/ApiValidateCouponRequest";
import { ApiValidateCouponResponse } from "shared/types/ApiValidateCouponResponse";

export function useValidateCouponCode() {
  return usePostApiData<ApiValidateCouponResponse, ApiValidateCouponRequest>(CommonApi.VALIDATE_COUPON_CODE);
}
